import type { Database } from 'node-sqlite3-wasm';
import { runCodeNavCacheWriteTransaction } from '../../sqlite/code-nav-cache/code-nav-cache-sqlite-transaction.js';
import { upsertFileIndexParentPath } from './file-index-parent-path.js';

type FileIndexInsertStatement = ReturnType<Database['prepare']>;

export function clearFileIndexChildPaths(db: Database, resolved: string): void {
  runCodeNavCacheWriteTransaction(db, () => {
    const parentId = upsertFileIndexParentPath(db, resolved);
    db.run('DELETE FROM file_index_child_path WHERE parent_id = ?', [parentId]);
  });
}

export function insertFileIndexChildPathBatch(db: Database, resolved: string, paths: readonly string[]): number {
  return runCodeNavCacheWriteTransaction(db, () => {
    const parentId = upsertFileIndexParentPath(db, resolved);
    const ins: FileIndexInsertStatement = db.prepare(
      'INSERT INTO file_index_child_path (parent_id, path) VALUES (?, ?)',
    );
    try {
      for (const rel of paths) {
        ins.run([parentId, rel]);
      }
      return paths.length;
    } finally {
      ins.finalize();
    }
  });
}
